import { Navigate, useLocation } from "react-router";

interface LegacyOnboardingRouteRedirectProps {
  legacyBasePath: string;
  canonicalBasePath: string;
}

/** Preserves the remainder of a legacy onboarding URL while replacing its base path. */
export function LegacyOnboardingRouteRedirect({
  legacyBasePath,
  canonicalBasePath,
}: LegacyOnboardingRouteRedirectProps) {
  const location = useLocation();
  const suffix = location.pathname.startsWith(legacyBasePath)
    ? location.pathname.slice(legacyBasePath.length)
    : "";

  return (
    <Navigate
      to={`${canonicalBasePath}${suffix}${location.search}${location.hash}`}
      replace
    />
  );
}
